import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import cx from 'classnames';
import { Button, SimpleText, Spin } from 'platform-components';
import React from 'react';

import './students__passport-button.scss';

interface Props {
    className?: string;
    disabled: boolean;
    loadingStatus: LOADING_STATUSES;
    onClick?: () => void;
    textId: string;
}

export const StudentsPassportButton = ({ className, disabled, loadingStatus, onClick, textId }: Props) => {
    const isLoading = loadingStatus === LOADING_STATUSES.LOADING;
    return (
        <Button className={cx('passport-button', className)} disabled={disabled || isLoading} onClick={onClick}>
            {isLoading ? <Spin center /> : <SimpleText id={textId} />}
        </Button>
    );
};
